'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _seriousRiskByYear = require('./serious-risk-by-year.component');

var _seriousRiskByYear2 = _interopRequireDefault(_seriousRiskByYear);

var _seriousRiskByYear3 = require('./serious-risk-by-year.service');

var _seriousRiskByYear4 = _interopRequireDefault(_seriousRiskByYear3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.seriousRiskByYear', [_angularUiRouter2.default]).component('seriousRiskByYear', _seriousRiskByYear2.default).service('SeriousRiskByYearService', _seriousRiskByYear4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('seriousRiskByYear', {
    parent: 'reports',
    url: '/serious-risk-by-year',
    component: 'seriousRiskByYear',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/serious-risk-by-year/serious-risk-by-year.module.js